module.exports = __webpack_public_path__ + "media/images/favicons/favicon-96x96-0135b59d013ec185bfa6ddcaafd59f45.png";